import { DefaultTheme } from 'styled-components';

import { color } from './colors';
import { font } from './fonts';

const theme: DefaultTheme = {
  color,
  font,
};

export default theme;
